import client from 'webpack-theme-color-replacer/client'
import forElementUI from 'webpack-theme-color-replacer/forElementUI'
import { generate } from '@ant-design/colors'

export function changeThemeColor(
  themeList = ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb']
) {
  const colorTemp = []

  // 设置element-ui的主题色
  colorTemp.push(...forElementUI.getElementUISeries(themeList[0]))
  // 设置ant-design的主题色
  colorTemp.push(...generate(themeList[0]))
  // 自定义的颜色梯度
  colorTemp.push(...themeList)

  client.changer.changeColor({
    newColors: colorTemp,
    changeUrl(cssUrl) { return `/${cssUrl}` }
  }, Promise).catch(err => {
    //
  })
}

